import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Icon, Message } from 'semantic-ui-react';
import { AppContext } from '../cnr/contexts/AppProvider';
import { _emailSignInStorageItem } from '../cnr/reducers/ValidationReducer';
import { useSignIn } from 'global/cnr/contexts/useHelpers/useSignIn';
import { _hostNames } from 'global/cnr/contexts/useHelpers/useHost';

export const EmailSignInConfirmationSimple = () => {

  const location = useLocation();

  const { loading, error, success, notification, completeEmailLinkSignIn } = useSignIn()

  // appContext
  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainApp, mainAuth, app_ts } = app_state ?? {}

  let _currentAuth = mainAuth

  const _host = document.location.host

  switch (_host) {
    case _hostNames.thumbstat:
      _currentAuth = app_ts.auth
      break;
    default:
      _currentAuth = app_ts.app
  }

  const _authDomain = _.get(_currentAuth, 'app._options.authDomain')

  useEffect(() => {
    const email = window.localStorage.getItem(_emailSignInStorageItem);
    completeEmailLinkSignIn(email)
  }, [mainAuth, location]);

  let iconName = loading ? 'circle notched' : success ? 'thumbs up' : 'thumbs down'
  let iconColor = loading ? 'grey' : success ? 'green' : 'red'

  return (
    <Container text style={{ marginTop: '2rem' }}>
      <Message icon>
        <Icon name={iconName} loading={loading} color={iconColor} />
        <Message.Content>
          <Message.Header>{notification?.title || 'Email Confirmation'}</Message.Header>
          <div>{notification?.content}</div>
          {_authDomain && <div style={{ fontSize: '.7rem' }}>{_authDomain}</div>}
        </Message.Content>
      </Message>
    </Container>
  );
}
